{
  "AGENT_BOTS": {
    "HEADER": "Bots",
    "LOADING_EDITOR": "Loading editor...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT_BADGE": "Järjestelmä",
    "AVATAR": {
      "SUCCESS_DELETE": "Botin avatar poistettu onnistuneesti",
      "ERROR_DELETE": "Botin avatarin poistaminen epäonnistui, yritä uudelleen"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Bot name",
        "PLACEHOLDER": "Name your bot.",
        "ERROR": "Bot name is required."
      },
      "DESCRIPTION": {
        "LABEL": "Bot description",
        "PLACEHOLDER": "What does this bot do?"
      },
      "BOT_CONFIG": {
        "ERROR": "Please enter your CSML bot configuration above.",
        "API_ERROR": "Your CSML configuration is invalid. Please fix it and try again."
      },
      "SUBMIT": "Validate and save"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Select an agent bot",
      "DESC": "Assign an Agent Bot to your inbox. They can handle initial conversations and transfer them to a live agent when necessary.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Päivitä",
      "DISCONNECT": "Disconnect bot",
      "SUCCESS_MESSAGE": "Successfully updated the agent bot.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Successfully disconnected the agent bot.",
      "ERROR_MESSAGE": "Could not update the agent bot. Please try again.",
      "DISCONNECTED_ERROR_MESSAGE": "Could not disconnect the agent bot. Please try again.",
      "SELECT_PLACEHOLDER": "Select bot",
      "COUNTRY_BOTS": {
        "TITLE": "Maakohtaiset botit",
        "DESC": "Tämä saapuneet-kansio palvelee useita maita. Keskustelu ohjataan oman maansa bottiin: Kauflandin verkkokaupan, Allegro-tilauksen kauppapaikan tai muuten asiakkaan kirjoituskielen mukaan. Kaikki muut keskustelut ohjataan yllä olevalle oletusbotille.",
        "COUNTRY": "Valitse maa",
        "BOT": "Valitse botti",
        "ADD": "Lisää botti maalle",
        "REMOVE": "Poista",
        "DEFAULT_REQUIRED": "Valitse ensin oletusbotti. Maan botti korvaa sen vain kyseisen maan osalta.",
        "DISCONNECT_ALL": "Irrota kaikki botit"
      }
    },
    "ADD": {
      "TITLE": "Configure new bot",
      "CANCEL_BUTTON_TEXT": "Peruuta",
      "API": {
        "SUCCESS_MESSAGE": "Bot added successfully.",
        "ERROR_MESSAGE": "Could not add bot. Please try again later."
      }
    },
    "LIST": {
      "404": "No bots found. You can create a bot by clicking the 'Configure new bot' button ↗",
      "LOADING": "Fetching bots...",
      "TABLE_HEADER": {
        "DETAILS": "Botin tiedot",
        "URL": "Webhook-URL"
      },
      "TYPE": "Bot type"
    },
    "DELETE": {
      "BUTTON_TEXT": "Poista",
      "TITLE": "Delete bot",
      "CONFIRM": {
        "TITLE": "Vahvista poistaminen",
        "MESSAGE": "Haluatko varmasti poistaa kohteen {name}?",
        "YES": "Kyllä, poista",
        "NO": "Ei, säilytä"
      },
      "SUBMIT": "Poista",
      "CANCEL_BUTTON_TEXT": "Peruuta",
      "DESCRIPTION": "Are you sure you want to delete this bot? This action is irreversible.",
      "API": {
        "SUCCESS_MESSAGE": "Bot deleted successfully.",
        "ERROR_MESSAGE": "Could not delete bot. Please try again."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Muokkaa",
      "LOADING": "Fetching bots...",
      "TITLE": "Edit bot",
      "CANCEL_BUTTON_TEXT": "Peruuta",
      "API": {
        "SUCCESS_MESSAGE": "Bot updated successfully.",
        "ERROR_MESSAGE": "Could not update bot. Please try again."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Botin avatar"
      },
      "NAME": {
        "LABEL": "Botin nimi",
        "PLACEHOLDER": "Anna botin nimi"
      },
      "DESCRIPTION": {
        "LABEL": "Kuvaus",
        "PLACEHOLDER": "Mitä tämä botti tekee?"
      },
      "WEBHOOK_URL": {
        "LABEL": "Webhook-URL",
        "PLACEHOLDER": "https://example.com/webhook"
      },
      "ERRORS": {
        "NAME": "Botin nimi on pakollinen",
        "URL": "Webhook-URL on pakollinen",
        "VALID_URL": "Anna kelvollinen URL-osoite, joka alkaa http:// tai https://"
      },
      "CANCEL": "Peruuta",
      "CREATE": "Luo botti",
      "UPDATE": "Päivitä botti"
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot",
      "CSML": "CSML bot"
    }
  }
}
